<div class="wrapper mb-5">
    <app-grupo-create-timeline [step]="3"></app-grupo-create-timeline>
    <div class="alert alert-light my-4" role="alert">
        <h4 class="alert-heading">Estamos quase lá!</h4>
        <p>Primeiro informe qual o valor que você irá disponibilizar no saldo FLEX, deste modo os favorecidos que serão adicionados a este grupo poderão utilizar livremente a quantia determinada respeitando os segmentos de utilização de cada produto.
            Em seguida e opcionalmente, você poderá pré-determinar uma quantia para cada produto, se for pré-determinado um valor, você irá garantir que uma quantia será utilizada pelo favorecido exclusivamente no segmento do produto selecionado.</p>
        <hr>
        <p class="mb-0">Exemplo:
            Você pode pré-determinar R$ 100,00 em VA e R$ 100,00 em VR e determinar R$ 300,00 para o FLEX. Estes R$ 300,00 do FLEX "Saldo Livre" poderá ser utilizado tanto no VR como no VA que permitirá ser utilizado tanto no VR como no VA.</p>
    </div>
    <div class="form-card mt-5">
        <span *ngIf="temFlexivel" class="subtitle">Havendo necessidade você também pode manter o FLEX com o saldo zero, e pré-determinae valores apenas para os demais produtos de benefícios</span>
        <!-- <div *ngFor="let item of rascunho.products">
            <div class="mt-5 grid-line">
                <div class="quarter">
                    <div class="frame">
                        <img class="white" [src]="item.urlIcone">
                        <span class="label-beneficio mt-3">{{item.produtoNome}}</span>
                    </div>
                </div>
                <div class="quarter grid-rows">
                    <div class="flex-center mb-4 space-between">
                        <div class="flex-center">
                            <div (click)="setPeriodo(1, item)" [ngClass]="item.standardPeriodCard === 1 ? 'checkbox-active' : 'checkbox-inactive'" class="custom-checkbox mb-1"></div>
                            <span (click)="setPeriodo(1, item)" class="label-checkbox" [ngClass]="item.standardPeriodCard === 1 ? 'label-active' : 'label-inactive'">Mensal</span>
                        </div>
                        <div class="flex-center">
                            <div (click)="setPeriodo(2, item)" [ngClass]="item.standardPeriodCard === 2 ? 'checkbox-active' : 'checkbox-inactive'" class="custom-checkbox mb-1"></div>
                            <span (click)="setPeriodo(2, item)" class="label-checkbox" [ngClass]="item.standardPeriodCard === 2 ? 'label-active' : 'label-inactive'">Diário</span>
                        </div>
                    </div>
                    <div class="col p-0">
                        <label [for]="'valor-beneficio-'+item.produtoId">Valor:</label>
                        <input [(ngModel)]="item.value" [textMask]="{mask: MASKS.currency.textMask}" type="text" [id]="'valor-beneficio-'+item.produtoId" placeholder="R$ 0,00">
                    </div>
                    <div class="flex-center mt-4">
                        <div class="checkbox-inactive custom-checkbox mb-1"></div>
                        <span>Limitar para dias úteis</span>
                    </div>
                </div>
                <div class="quarter grid-rows">
                    <div class="col p-0 row-2">
                        <label for="valor-beneficio">Qual o valor máximo diário?</label>
                        <input type="text" id="valor-beneficio" placeholder="R$ 0,00">
                    </div>

                    <div class="flex-center mt-4 row-3">
                        <div class="checkbox-inactive custom-checkbox mb-1"></div>
                        <span>Ilimitado</span>
                    </div>
                </div>
                <div class="quarter grid-rows">
                    <div class="col p-0 row-2">
                        <label for="valor-beneficio">Onde posso usar?</label>
                        <input type="text" id="valor-beneficio" placeholder="0km">
                    </div>

                    <div class="flex-center mt-4 row-3">
                        <div class="checkbox-inactive custom-checkbox mb-1"></div>
                        <span>Ilimitado</span>
                    </div>
                </div>

            </div>
            <div class="line mt-5"></div>
        </div> -->
        <div *ngIf="temFlexivel" class="row m-0 mt-4 w-40">
            <div class="quarter col-12 col-sm-4 p-0">
                <div class="frame" [ngStyle]="{'background-color': flexivel.color ? flexivel.color : '#31373f'}">
                    <img class="white" src="https://seuvale-imagens-fixas.s3-sa-east-1.amazonaws.com/Icones-beneficios/FLEX.svg">
                    <span class="label-beneficio mt-3">FLEX</span>
                </div>
            </div>
            <!-- <div class="col p-0 col-12 col-sm-3 mr-5">
                <label for="valor-beneficio-total">Valor total dos produtos:</label>
                <input [(ngModel)]="valorFlex" number [textMask]="{mask: MASKS.currency.textMask}" type="text" id="valor-beneficio-total" placeholder="R$ 0,00">
            </div> -->
            <div class="col p-0 col-12 col-sm-3 no-select">
                <div class="flex-center mb-4 space-between">
                    <div class="flex-center">
                        <div (click)="setPeriodo(1, flexivel)" [ngClass]="flexivel.standardPeriodCard === 1 ? 'checkbox-active' : 'checkbox-inactive'" class="custom-checkbox mb-1"></div>
                        <span (click)="setPeriodo(1, flexivel)" class="label-checkbox" [ngClass]="flexivel.standardPeriodCard === 1 ? 'label-active' : 'label-inactive'">Mensal</span>
                    </div>
                    <div class="flex-center">
                        <div (click)="setPeriodo(2, flexivel)" [ngClass]="flexivel.standardPeriodCard === 2 ? 'checkbox-active' : 'checkbox-inactive'" class="custom-checkbox mb-1"></div>
                        <span (click)="setPeriodo(2, flexivel)" class="label-checkbox" [ngClass]="flexivel.standardPeriodCard === 2 ? 'label-active' : 'label-inactive'">Diário</span>
                    </div>
                </div>
                <label for="valor-beneficio-flex">Valor do produto FLEX:</label>
                <input [(ngModel)]="valorFlex"  currencyMask [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }" type="text" id="valor-beneficio-flex" placeholder="R$ 0,00">
            </div>
        </div>
        <div *ngIf="temFlexivel" class="line mt-5 mb-4"></div>
        <span class="subtitle">Configure os seus produtos</span>
        <div class="row m-0 mt-4">
            <div *ngFor="let item of rascunho.products" class="col-12 col-sm-6 col-xl-4 margin-custom p-0 mt-4 pr-4">
                <div class="row m-0">
                    <div class="quarter mr-3 col-12 col-sm-6 p-0">
                        <div class="small-frame" [ngStyle]="{'background-color': item.color ? item.color : '#31373f'}">
                            <img class="white" [src]="item.urlIcone">
                            <span class="label-beneficio mt-1">{{item.produtoNome}}</span>
                        </div>
                    </div>
                    <div class="col p-0 col-12 col-sm-5">
                        <div class="row mb-4 mx-0">
                            <div class="flex-center">
                                <div (click)="setPeriodo(1, item)" [ngClass]="item.standardPeriodCard === 1 ? 'checkbox-active' : 'checkbox-inactive'" class="custom-checkbox mb-1"></div>
                                <span (click)="setPeriodo(1, item)" class="label-checkbox" [ngClass]="item.standardPeriodCard === 1 ? 'label-active' : 'label-inactive'">Mensal</span>
                            </div>
                            <div class="flex-center">
                                <div (click)="setPeriodo(2, item)" [ngClass]="item.standardPeriodCard === 2 ? 'checkbox-active' : 'checkbox-inactive'" class="custom-checkbox mb-1"></div>
                                <span (click)="setPeriodo(2, item)" class="label-checkbox" [ngClass]="item.standardPeriodCard === 2 ? 'label-active' : 'label-inactive'">Diário</span>
                            </div>
                        </div>
                        <label [for]="'valor-beneficio-'+item.produtoId">Valor mínimo:</label>
                        <input [(ngModel)]="item.value" [id]="'valor-beneficio-'+item.produtoId" currencyMask [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }" type="text" placeholder="R$ 0,00">
                    </div>
                    <div class="col-lg-12 col-md-12 col-sm-12 my-3 p-0">
                        <p class="card-subtitle">{{item.produtoDescImportante}}</p>
                    </div>
                </div>
            </div>
        </div>
        <button (click)="finish()" class="white-button mt-5">Finalizar</button>
    </div>
</div>
